export type DetectedBrowser = "chrome" | "edge" | "firefox" | "safari"

// Order matters: Edge also carries "Chrome/", and every Chromium build carries "Safari/".
export const detectBrowser = (): DetectedBrowser | null => {
  const ua = navigator.userAgent
  if (ua.includes("Edg/")) return "edge"
  if (ua.includes("Firefox/")) return "firefox"
  if (ua.includes("Chrome/")) return "chrome"
  if (ua.includes("Safari/")) return "safari"

  return null
}
